import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const bannerButton = css`
  width: 100%;
`;

export const banner = css`
  width: 100%;
  height: 18.75rem;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: var(--banner-image);
  @media screen and (max-width: ${dimensions.desktop}) {
    height: 5.5rem;
  }
}
`;
